import styled from 'styled-components'

import { Skeleton } from '@blade/ui-kit'

export const ProfileHeaderSkeleton: React.FC = () => (
  <Root>
    <Top>
      <Main>
        <MainBody>
          <ActionSkeleton>
            <Skeleton width={12} height={12} />
          </ActionSkeleton>
          <Skeleton width={60} height={60} variant="circular" />
          <MainContent>
            <Skeleton width={140} height={16} />
            <MainSubtitle>
              <Skeleton width={90} height={24} />
              <Skeleton width={90} height={24} />
            </MainSubtitle>
          </MainContent>
        </MainBody>
      </Main>
      <Connections>
        <Connection>
          <Skeleton width={24} height={14} />
          <Skeleton width={56} height={12} />
        </Connection>
        <Separator />
        <Connection>
          <Skeleton width={24} height={14} />
          <Skeleton width={56} height={12} />
        </Connection>
      </Connections>
    </Top>
    <Bottom>
      <Ranks>
        {Array.from({ length: 3 }).map((_, index) => (
          <Rank key={index}>
            <Skeleton width={13} height={13} />
            <Skeleton width={16} height={13} />
            <Skeleton width={48} height={12} />
          </Rank>
        ))}
      </Ranks>
    </Bottom>
  </Root>
)

const Root = styled.div``

const Bottom = styled.div`
  border-bottom: 1px solid var(--backgroundA-3);
`

const Top = styled.div`
  position: relative;
  border-radius: 12px;
  border: 1px solid var(--backgroundA-2);
  background: var(--backgroundA-2);
`

const Main = styled.div`
  margin: -1px;
  padding: 18px;
  border-radius: 12px;
  background:
    radial-gradient(
      circle at 60% -40%,
      var(--primary-1),
      var(--background-1) 65%
    ),
    var(--background-1);

  display: grid;
  gap: 10px;
`

const MainBody = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 20px;
`

const MainContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: center;
`

const MainSubtitle = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`

const ActionSkeleton = styled.div`
  position: absolute;
  top: 4px;
  right: 4px;
  display: flex;
  padding: 8px;
  border-radius: 8px;
  width: 28px;
  height: 28px;
  background: var(--backgroundA-2);
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
`

const Connections = styled.div`
  display: grid;
  grid-template-columns: 1fr 1px 1fr;
`

const Separator = styled.div`
  margin: 8px 0;
  background: var(--backgroundA-3);
`

const Connection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 10px;
`

const Ranks = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
`

const Rank = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 10px;
`
